if (window.location.href.includes("remesas")) {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const tableBody = document.querySelector("#TablaRemesas tbody");

    function claseEstadoRemesa(estado) {
        const clases = {
            "PENDIENTE": "td-1",
            "ENVIADO": "td-2",
            "ERROR": "td-3",
        };
        return clases[estado] || "";
    }

    function actualizarTabla(signal, { esRefrescoSilencioso = false } = {}) {
        if (!tableBody) return;

        const filtroBuscar = document.getElementById("filtroBuscar").value;
        const filtroEstado = document.getElementById("filtroEstado").value;
        const filtroFecha = document.getElementById("filtroFecha").value;

        if (!esRefrescoSilencioso) {
            window.mostrarFilasEsqueleto(tableBody, 9);
        }

        const params = new URLSearchParams({
            filtroBuscar,
            filtroEstado,
            filtroFecha,
        });
        const url = `/api/remesas?${params.toString()}`;

        return fetch(url, { ...requestOptions, cache: "no-store", signal, sinCargando: true })
            .then((response) => {
                if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
                return response.json();
            })
            .then((result) => {
                tableBody.innerHTML = "";
                const data = result.result;
                data.resultado.forEach((item) => {
                    const row = document.createElement("tr");
                    const deshabilitar = item.estado === "ENVIADO" ? "disabled" : "";
                    row.innerHTML = `
                        <td><input type="checkbox" class="chk-remesa" data-id="${item.id_remesa}" ${deshabilitar} aria-label="Seleccionar remesa ${item.remesa}"></td>
                        <td>${item.remesa}</td>
                        <td>${item.fecha_creacion}</td>
                        <td class="td-d">${item.nombre_destinatario}</td>
                        <td>${item.codigo_destino}</td>
                        <td class="td-num">${Number(item.cajas).toLocaleString()}</td>
                        <td class="td-num">${Number(item.kilos).toLocaleString()}</td>
                        <td><div class="${claseEstadoRemesa(item.estado)}"><p class="p-color">${item.estado}</p></div></td>
                        <td class="td-d">${item.mensaje ?? ""}</td>
                    `;
                    tableBody.appendChild(row);
                });

                if (data.num_registros === 0) {
                    const row = document.createElement("tr");
                    row.classList.add("no-data");
                    row.innerHTML = `
                        <td colspan="9">
                            <div class="cont-no-data">
                                No se encontró información.
                                <img class="icono-pequeño-gris" src="/public/build/img/icons/alerta.svg" alt="">
                            </div>
                        </td>`;
                    tableBody.appendChild(row);
                }
            });
    }

    const actualizador = window.crearActualizadorApi(actualizarTabla);

    // Expuesta para refrescar inmediatamente después de enviar remesas a AGV.
    window.actualizarTablaRemesas = actualizador.actualizarAhora;

    document.getElementById("filtroBuscar").addEventListener("input", actualizador.alCambiarFiltro);
    document.getElementById("filtroEstado").addEventListener("change", actualizador.alCambiarFiltro);
    document.getElementById("filtroFecha").addEventListener("change", actualizador.alCambiarFiltro);

    // Limpiar filtros
    const btnLimpiarFiltros = document.getElementById("btnLimpiarFiltros");
    if (btnLimpiarFiltros) {
        btnLimpiarFiltros.addEventListener("click", () => {
            document.getElementById("filtroBuscar").value = "";
            document.getElementById("filtroEstado").value = "";
            document.getElementById("filtroFecha").value = "";
            actualizador.alCambiarFiltro();
        });
    }

    // Carga inicial inmediata y siguientes actualizaciones cada 5 minutos.
    actualizador.iniciar();
}
